import type { ApiResponse } from '@shared/types'
import { createService } from 'v2/shared/services/create-service'
import { BackendServiceName } from 'v2/types'
import type {
  HandoffContext,
  HandoffContextSource,
  RCallHandoffPreview,
} from 'v2/types/api/handoff-context'

// Hodor's workflow routing selects human-specialist; the browser never holds a source secret after setup.
const client = createService('', true, BackendServiceName.workflow, 'v1')

export const handoffContextService = {
  getCallPreview: (number: string) =>
    client.get<ApiResponse<RCallHandoffPreview>>(
      `/conversations/${encodeURIComponent(number)}/handoff-context-preview`,
    ),
  getContext: (number: string) =>
    client.get<ApiResponse<HandoffContext>>(
      `/conversations/${encodeURIComponent(number)}/handoff-context`,
    ),
  listSources: () => client.get<ApiResponse<HandoffContextSource[]>>('/handoff-context/sources'),
  createSource: (name: string) =>
    client.post<ApiResponse<HandoffContextSource>>('/handoff-context/sources', { name }),
  rotateSource: (uuid: string) =>
    client.post<ApiResponse<HandoffContextSource>>(
      `/handoff-context/sources/${encodeURIComponent(uuid)}/rotate`,
    ),
  revokeSource: (uuid: string) =>
    client.post<ApiResponse<HandoffContextSource>>(
      `/handoff-context/sources/${encodeURIComponent(uuid)}/revoke`,
    ),
  bindFlow: (uuid: string, phlo_uuid: string) =>
    client.post<ApiResponse<HandoffContextSource>>(
      `/handoff-context/sources/${encodeURIComponent(uuid)}/flows`,
      { phlo_uuid },
    ),
}
